import clsx from 'clsx';
import { LuX } from 'react-icons/lu';
import { RoundButton, RoundButtonProps } from './RoundButton';

export const RoundCloseButton = ({
  size = 'md',
  ...props
}: RoundButtonProps) => (
  <RoundButton color="red" size={size} {...props}>
    <LuX
      className={clsx(
        size === 'xs' && 'text-4xl',
        size === 'sm' && 'text-4xl',
        size === 'md' && 'text-6xl',
        size === 'lg' && 'text-8xl',
      )}
    />
  </RoundButton>
);
